import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {analyticsClient} from '../../../analytics-client';
import {nutApolloClient} from '../../../apollo-client';
import {appHistory} from '../../../history';
import {store} from '../../../store';

import {GetUser} from '../../core/get-user';

import {MFASetup} from './mfa-setup';

export function mountMfa(userId?: string | null) {
    const mfaOpenModalMount = document.querySelector('#mfa-mount-for-react');

    if (mfaOpenModalMount) {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_2FA_USER_CONFIGURATION_STARTED);

        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <GetUser userId={userId ? `${userId}` : ''}>
                                {({user, isLoadingUser}) => {
                                    return <MFASetup user={user} isLoadingUser={isLoadingUser} />;
                                }}
                            </GetUser>
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            mfaOpenModalMount
        );
    }
}
